export default {
  path: 'temporary-regulations/work-orders',
  name: 'TemporaryRegulationsWorkOrders',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/WorkOrdersIndex.vue')
}
